<template>
    <v-container>
        <v-card class="mx-auto" max-width="800">
            <v-card-title>Upload Images</v-card-title>
            <v-card-text>
                <v-file-input v-model="images" label="Choose images" accept=".jpg, .jpeg, .png" outlined multiple
                    counter show-size chips></v-file-input>
                    <v-textarea
                    outlined
                    name="input-7-4"
                    label="Prompt"
                    v-model="prompt"
        ></v-textarea>
            </v-card-text>
            <v-card-actions>
                <v-btn color="primary" :disabled="!images" @click="uploadImages">Upload</v-btn>
                <v-btn color="secondary" @click="analyzeImages" :disabled="!uploadedImages.length">
                    Process Images
                </v-btn>
            </v-card-actions>
        </v-card>
        <v-alert v-if="message" :type="alertType" class="mx-auto mt-4" max-width="800" dismissible>{{ message }}</v-alert>
    <v-alert v-if="progressMessage" type="info" class="mx-auto mt-4" max-width="800">{{ progressMessage }}</v-alert>
        <div v-for="(response, index) in analyzedResponses" :key="index">
            <analyzed-image :imageUrl="uploadedImages[index].url" :response="response"></analyzed-image>
        </div>
    </v-container>
</template>

<script>
import axios from 'axios';
import AnalyzedImage from './AnalyzedImage.vue';

export default {
    components: { AnalyzedImage },
    data() {
        return {
            images: null,
            uploadedImages: [],
            message: '',
            alertType: 'success',
            aiResponse: null,
            analyzedResponses: [],
            progressMessage: '',
            prompt: 'Questa è una foto riguardante un ambiente di lavoro. Dovrai rispondere dando una valutazione di sicurezza sul lavoro in base alle norme italiane.'
        };
    },
    methods: {
        uploadImages() {
            if (!this.images) {
                this.message = 'Please select images first';
                this.alertType = 'error';
                return;
            }

            const formData = new FormData();
            this.images.forEach((singleImage, index) => {
                formData.append(`file[${index}]`, singleImage);
            });

            axios
                .post('/file/upload', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                })
                .then((response) => {
                    this.message = response.data.message;
                    this.alertType = 'success';
                    this.uploadedImages = response.data.files;
                })
                .catch((error) => {
                    this.message = error.response?.data.message || 'Failed to upload files';
                    this.alertType = 'error';
                });
        },
        async analyzeImages() {
            this.analyzedResponses = [];
            this.progressMessage = '';

            for (let i = 0; i < this.uploadedImages.length; i++) {
                this.progressMessage = `Analizzo immagine ${i + 1} di ${this.uploadedImages.length}`;

                try {
                    const response = await axios.post('/file/analyze', {
                        path: this.uploadedImages[i].path,
                        prompt: this.prompt
                    });

                    this.analyzedResponses.push(response.data);
                    console.log(response.data);
                } catch (error) {
                    this.message = error.response?.data.message || 'Failed to analyze image';
                    this.alertType = 'error';
                    break;
                }
            }

            this.progressMessage = '';
            this.alertType = 'success';
            this.message = 'Analisi completata';
        },
    },
};
</script>
